import {
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/base-components/Icon";
import { Pill } from "src/base-components/Pill";
import {
  ToolApprovalStatusEnum,
  ToolUse,
  ToolUseStatusEnum,
  ToolUseTypeEnum,
} from "src/clients/copilot";

type Props = {
  toolUse: ToolUse;
};

/**
 * Returns display configuration based on tool use type and status
 */
const getDisplayConfig = (
  toolUse: ToolUse,
): { isSuccess: boolean; message: string } => {
  switch (toolUse.type) {
    case ToolUseTypeEnum.APPROVAL:
      if (
        (toolUse.status as unknown as ToolApprovalStatusEnum) ===
        ToolApprovalStatusEnum.APPROVED
      ) {
        return { isSuccess: true, message: "approved by you" };
      }
      return { isSuccess: false, message: "permission denied" };
    case ToolUseTypeEnum.RESULT:
      switch (toolUse.status) {
        case ToolUseStatusEnum.SUCCESS:
          return { isSuccess: true, message: "executed successfully" };
        case ToolUseStatusEnum.DENIED:
          return { isSuccess: false, message: "permission denied" };
        case ToolUseStatusEnum.ERROR:
          return { isSuccess: false, message: "execution failed" };
        default:
          return { isSuccess: false, message: "unknown status" };
      }
    default:
      return { isSuccess: false, message: "unknown status" };
  }
};

export const ToolApprovalResultCard: React.FC<Props> = ({ toolUse }) => {
  const { isSuccess, message } = getDisplayConfig(toolUse);

  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-2">
      <div className="flex items-center gap-x-2">
        <Icon
          color={isSuccess ? "text-green-500" : "text-red-500"}
          icon={isSuccess ? faCircleCheck : faCircleXmark}
          size="sm"
        />
        <Pill size="sm" variant="gray">
          <span className="font-mono text-xs">{toolUse.tool_name}</span>
        </Pill>
        <span className="font-inter-normal-12px text-gray-600">{message}</span>
      </div>
    </div>
  );
};
